import { Grid } from '@material-ui/core';
import Authorize from 'components/Authorize';
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import CustomInput from 'components/CustomInput';
import { setAccessToEdit } from 'features/access/accessStateSlice';
import { useGetClientsQuery } from 'features/clients/clientSlice';
import { selectIsClient, userHasOneClient } from 'features/user/userSlice';
import { useDispatch, useSelector } from 'react-redux';

const ClientFields = ({ }) => {
    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery();
    const clientAccounts = clients?.flatMap(c => c.clientAccounts);
    const isClient = useSelector(selectIsClient);
    const hasOneClaim = useSelector(userHasOneClient);
    const { accessToEdit } = useSelector(state => state.accessState);
    const dispatch = useDispatch();

    const onChangeValue = (clientAccountId) => {
        let clientId = clientAccounts?.find(a => a.id === clientAccountId)?.clientId;
        let access = { ...accessToEdit };
        access.clientAccountId = clientAccountId;
        access.clientId = clientId;
        dispatch(setAccessToEdit(access))
    }

    return (
        <>
            {/* <Authorize profile={permissionProfiles.ACCESS.CLIENT_FIELDS}> */}
            {(!isClient || !hasOneClaim) && <Grid item>
                <CustomInput
                    label='Client'
                    elementType='dropdown'
                    value={accessToEdit?.clientAccountId}
                    values={clientAccounts}
                    onChange={(val) => onChangeValue(+val)}
                    showEmpty
                    required
                />
            </Grid>}
            {/* </Authorize> */}
        </>
    );
}

export default ClientFields;